var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitment5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_172474",
    "data-name": "\\uADF8\\uB8F9 172474",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.537,
    height: 55.167,
    viewBox: "0 0 48.537 55.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121627",
    "data-name": "\\uD328\\uC2A4 121627",
    d: "M761.018,768.44c-22.174,20.226-20.062,38.444-20.062,38.444s12.5,6.554,29.1,13.023c0-23.645,17.142-33.88,17.142-33.88S766.663,774.328,761.018,768.44Z",
    transform: "translate(-738.657 -764.74)",
    fill: "#6b6b6b",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121628",
    "data-name": "\\uD328\\uC2A4 121628",
    d: "M747.545,746.241c-22.174,20.226-20.062,38.444-20.062,38.444s12.5,6.554,29.1,13.023c0-23.645,17.142-33.88,17.142-33.88S753.19,752.13,747.545,746.241Z",
    transform: "translate(-727.429 -746.241)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121629",
    "data-name": "\\uD328\\uC2A4 121629",
    d: "M853.328,795.881c-1.556-1.021-3.109-2.047-4.673-3.057q-4.74-3.062-9.5-6.092c-.461-.293-.831.459-.383.751q4.673,3.054,9.367,6.073c1.563,1.006,3.136,2,4.706,2.992a44.406,44.406,0,0,0,4.773,2.861.231.231,0,0,0,.258-.377A44.1,44.1,0,0,0,853.328,795.881Z",
    transform: "translate(-820.045 -779.927)",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121630",
    "data-name": "\\uD328\\uC2A4 121630",
    d: "M838.873,823.565c-.789-.486-1.59-.954-2.386-1.428-1.556-.927-3.108-1.86-4.668-2.781-3.154-1.861-6.3-3.74-9.48-5.559-.468-.268-.831.467-.377.741,3.135,1.895,6.307,3.733,9.467,5.585,1.562.915,3.13,1.818,4.7,2.727.8.465,1.6.937,2.405,1.39a12.049,12.049,0,0,0,2.3,1.16c.225.068.34-.239.193-.382A12.193,12.193,0,0,0,838.873,823.565Z",
    transform: "translate(-806.03 -802.488)",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121631",
    "data-name": "\\uD328\\uC2A4 121631",
    d: "M819.352,847.379c-.762-.456-1.533-.9-2.3-1.341q-2.415-1.4-4.836-2.782-4.843-2.77-9.689-5.533c-.491-.279-.881.5-.4.778q4.832,2.789,9.677,5.557,2.42,1.387,4.847,2.762c.808.459,1.616.919,2.431,1.366a10.5,10.5,0,0,0,2.348,1.085c.205.054.308-.212.175-.345A11.159,11.159,0,0,0,819.352,847.379Z",
    transform: "translate(-789.492 -822.424)",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121632",
    "data-name": "\\uD328\\uC2A4 121632",
    d: "M798.9,878.778q-2.645-1.228-5.3-2.433l-5.422-2.476q-1.327-.606-2.653-1.211c-.462-.21-.925-.418-1.388-.626a2.98,2.98,0,0,0-.569-.246c-.173-.035-.337.059-.514.035a.187.187,0,0,0-.162.32c.149.132.192.306.34.43a2.337,2.337,0,0,0,.507.244c.46.213.921.426,1.382.637q1.384.632,2.77,1.262l5.309,2.418q2.713,1.236,5.43,2.46a27.8,27.8,0,0,0,5.354,2.137c.141.03.259-.168.133-.263A28.375,28.375,0,0,0,798.9,878.778Z",
    transform: "translate(-773.591 -850.852)",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121633",
    "data-name": "\\uD328\\uC2A4 121633",
    d: "M782.781,911.471q-2.4-1.123-4.808-2.244c-3.282-1.524-6.54-3.126-9.858-4.571-.456-.2-.8.47-.353.693,3.246,1.6,6.572,3.054,9.855,4.577q2.465,1.143,4.933,2.277a29.941,29.941,0,0,0,4.825,2.058c.2.053.377-.252.194-.382A30.723,30.723,0,0,0,782.781,911.471Z",
    transform: "translate(-760.863 -878.22)",
    fill: "#303030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121634",
    "data-name": "\\uD328\\uC2A4 121634",
    d: "M771.91,949.241c-.8-.394-1.611-.768-2.417-1.149-1.576-.744-3.161-1.467-4.742-2.2q-4.859-2.251-9.725-4.487c-.507-.234-.9.54-.394.773q4.866,2.237,9.735,4.467c1.624.742,3.243,1.495,4.873,2.223.815.365,1.627.739,2.449,1.087a9.23,9.23,0,0,0,2.336.836.157.157,0,0,0,.136-.268A9.46,9.46,0,0,0,771.91,949.241Z",
    transform: "translate(-749.901 -908.838)",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment5);
export default __webpack_public_path__ + "static/media/recruitment5.6695e4f23eecc68a8c49ef2b66809e10.svg";
export { ForwardRef as ReactComponent };